import { set, toggle } from '@/utils/vuex'

export default {
  setUser (state, user){
  	state.user = user
  },
  setLogged(state, logged){
  	state.logged = logged
  }, 
  setApiToken(state, apiToken){
  	state.apiToken = apiToken
  },
  setMenu(state, menu){
  	state.menu = menu
  },
}
